<template>
    <section class="featured-school-section">
        <div class="custom-container">
            <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-lg-3" v-for="item in featuredschool" :key="item.id">
                    <div class="featuredschool-widget">
                        <div class="featuredschool-img">
                            <router-link to="/profile"><img :src="loadImg(item.image)" alt="school" class="img-fluid" /></router-link>
                        </div>
                        <div class="featuredschool-info">
                            <div class="featuredschool-name">	
                                <h2>{{item.school_type}}</h2>
                                <h3><router-link to="/profile">{{item.school}}</router-link></h3>
                            </div>
                            <div class="featuredschool-features">
                                <ul>
                                    <li><router-link to="/profile">INFORMATION</router-link></li>
                                    <li><router-link to="/course">CURRICULUM</router-link></li>
                                    <li><router-link to="/booking">APPLY ONLINE</router-link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <div class="slider-section-header">
                        <h2>FEATURED SCHOOL</h2>
                        <p>We are proud of our international and multi-cultural ethos, and the way our community collaborates to make a difference.</p>
                        <router-link to="/map-list" class="btn btn-fill">View All</router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import featuredschool from '../../../assets/json/featuredschool'
const images = require.context('@/assets/img/schools', false, /\.png$|\.jpg$/)

export default {
    data() {
        return {
            featuredschool: featuredschool
        }
    },
     methods: {
        loadImg(imgPath) {
            return images('./' + imgPath)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Home/FeaturedSchool/index.vue